var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { TruncateString } from '@snack-uikit/truncate-string';
import { extractSupportProps } from '@snack-uikit/utils';
import { APPEARANCE, PURPOSE, SIZE, TARGET, TEXT_MODE } from './constants';
import styles from './styles.module.css';
/** Компонент ссылка */
export function Link(_a) {
    var _b, _c;
    var { text = '', className, textMode = TEXT_MODE.Default, size = SIZE.S, purpose = PURPOSE.Body, appearance = APPEARANCE.Primary, insideText = false, truncateVariant, as } = _a, rest = __rest(_a, ["text", "className", "textMode", "size", "purpose", "appearance", "insideText", "truncateVariant", "as"]);
    const Component = as || 'a';
    let fallbackProps;
    if (Component === 'a') {
        /**
         * Обратно совместимые изменения с предыдущей версией.
         */
        fallbackProps = Object.assign({ target: (_b = rest === null || rest === void 0 ? void 0 : rest.target) !== null && _b !== void 0 ? _b : TARGET.Blank, href: (_c = rest.href) !== null && _c !== void 0 ? _c : '#', download: rest.download, onClick: rest.onClick }, extractSupportProps(rest));
        fallbackProps.rel = fallbackProps.target === TARGET.Blank ? 'noopener noreferrer' : undefined;
    }
    else {
        fallbackProps = rest;
    }
    return (_jsx(Component, Object.assign({ className: cn(styles.link, className) }, fallbackProps, { "data-size": size, "data-purpose": purpose, "data-text-mode": textMode, "data-appearance": appearance, "data-inside-text": insideText || undefined, children: insideText ? text : _jsx(TruncateString, { text: text, maxLines: 1, variant: truncateVariant }) })));
}
